// Declare this also in custom js files to avoid overriding
import { getFieldValue } from './utilities/form';

window.CoreTriggerActions = window.CoreTriggerActions || {};

window.CoreTriggerActions.show = function (trigger, action, targetEl) {
    targetEl.classList.remove('d-none');
};

window.CoreTriggerActions.hide = function (trigger, action, targetEl) {
    targetEl.classList.add('d-none');
};

window.CoreTriggerActions.copy = function (trigger, action, targetEl, changedInput) {
    if (targetEl && changedInput) {
        const input = targetEl.querySelector('input');

        if (input) {
            input.value = getFieldValue(changedInput).value;
        }
    }
};

window.CoreTriggerActions.checkIfMoreThanAndErrorField = function (trigger, action, targetEl, changedInput) {
    const wrapper = changedInput.closest('.field-holder');
    const input = changedInput;
    const feedback = wrapper.querySelector('[data-feedback]');

    if (action.params.value && Number.parseFloat(input.value) > Number.parseFloat(action.params.value)) {
        input.classList.add('is-invalid');
        feedback.innerHTML = action.params.message;
    } else {
        input.classList.remove('is-invalid');
        feedback.innerHTML = '';
    }
};

window.CoreTriggerActions.checkIfValueIsMore = function (trigger, action, targetEl, changedInput) {
    const wrapper1 = changedInput.closest('.field-holder');
    const wrapper2 = targetEl;
    const input1 = wrapper1.querySelector('input');
    const input2 = wrapper2.querySelector('input');
    const feedback1 = wrapper1.querySelector('[data-feedback]');
    const feedback2 = wrapper2.querySelector('[data-feedback]');

    const condition = action.params.reverse ? Number.parseFloat(input1.value) < Number.parseFloat(input2.value) : Number.parseFloat(input1.value) > Number.parseFloat(input2.value);

    if (condition) {
        input1.classList.add('is-invalid');
        feedback1.innerHTML = action.params.message;
        input2.classList.add('is-invalid');
        feedback2.innerHTML = action.params.message;
    } else {
        input1.classList.remove('is-invalid');
        feedback1.innerHTML = '';
        input2.classList.remove('is-invalid');
        feedback2.innerHTML = '';
    }
};

window.CoreTriggerActions.clearSelect = function (trigger, action, targetEl) {
    const selectController = Stimulus.getControllerForElementAndIdentifier(targetEl, 'select');

    if (selectController && selectController.select) {
        selectController.additionalQuery = '';
        selectController.select.clear();
        selectController.select.clearOptions();
    }
};

window.CoreTriggerActions.reloadSelect = function (trigger, action, targetEl) {
    const selectController = Stimulus.getControllerForElementAndIdentifier(targetEl, 'select');

    if (selectController && selectController.select) {
        selectController.select.load('');
        selectController.select.wrapper.classList.add('preloaded');
    }
};

window.CoreTriggerActions.updateSelectQuery = function (trigger, action, targetEl) {
    const selectController = Stimulus.getControllerForElementAndIdentifier(targetEl, 'select');

    if (selectController && selectController.select) {
        if (action.params.with?.length) {
            selectController.additionalQuery = '';

            for (const withElement of action.params.with) {
                const field = trigger.getField(withElement);

                if (field) {
                    const fieldKey = field.name;
                    const fieldValue = getFieldValue(field).value;

                    if (Array.isArray(fieldValue)) {
                        for (const v of fieldValue) {
                            selectController.additionalQuery += `&${encodeURIComponent(fieldKey)}=${encodeURIComponent(v)}`;
                        }
                    } else {
                        selectController.additionalQuery += `&${encodeURIComponent(fieldKey)}=${encodeURIComponent(fieldValue)}`;
                    }
                }
            }
        }
    }
};

function hasTriggerAction(actionName) {
    return window.CoreTriggerActions[actionName];
}

function callTrigger(trigger, action, targetEl, changedInput) {
    if (!hasTriggerAction(action.name)) {
        return;
    }

    window.CoreTriggerActions[action.name](trigger, action, targetEl, changedInput);
}

export {
    callTrigger,
};
